import type { AssetTechnicalUpdateProps } from "./asset-technical-update.type";

import { Card } from "antd";

import { AssetTechnicalForm } from "@/modules/asset/asset-technical-form";
import AssetTechnicalUpdateHistory from "@/modules/asset/asset-technical-update-history";

import { useAssetTechnicalDataUpdate } from "./asset-technical-update.hook";

export const AssetTechnicalUpdate = ({ asset }: AssetTechnicalUpdateProps) => {
  const { handleDataChange, schema, isLoading, form, lastTechnicalUpdate } =
    useAssetTechnicalDataUpdate(asset);

  return (
    <Card
      loading={isLoading}
      title={
        lastTechnicalUpdate && (
          <AssetTechnicalUpdateHistory
            lastTechnicalUpdate={lastTechnicalUpdate}
          />
        )
      }
    >
      <AssetTechnicalForm
        schema={schema}
        handleChange={handleDataChange}
        form={form}
      />
    </Card>
  );
};
